import { useMutation } from "@tanstack/react-query";

import { getBackendApiErrorResponse } from "~/core/axios";
import { axios } from "~/core/axios";
import { REACT_QUERY_KEY } from "~/core/constants/common";
import { BackendApiResponse } from "~/core/types/backend-api-response.type";

export const useSubscriptionCheckout = () => {
  return useMutation({
    mutationKey: [REACT_QUERY_KEY.SUBSCRIPTION_CHECKOUT],
    mutationFn: async (plan: string) => {
      try {
        const { data } = await axios.get<BackendApiResponse<string>>(
          `/subscription/checkout/${plan}`,
        );

        if (data && data.data) {
          window.location.href = data.data;
        }
      } catch (error) {
        const err = getBackendApiErrorResponse(error);
        console.error(err.data.message);
        throw error;
      }
    },
  });
};
